export default "__VITE_ASSET__NMX1eQ$G__"